import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  receiptIssues: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "receiptIssue",
  initialState,
  reducers: {
    getReceiptIssueSuccess: (state, { payload }) => {
      state.receiptIssues = payload;
      state.loading = false;
    },
    startLoadingReceiptIssue: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllReceiptIssues = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoadingReceiptIssue());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-receiptIssues`,
        { headers }
      );
      dispatch(slice.actions.getReceiptIssueSuccess(res.data));
       
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};
